import React, { ReactNode, useState } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { ChoiceGroup, ChoiceGroupItem } from '@fiverr-private/forms';
import { Text } from '@fiverr-private/typography';
import { AppI18n } from '../../../i18n';
import { NOT_SURE_METADATA_KEY } from '../../../constants';
import { SelectProps } from './MetadataSection';
import { NotSureDescription } from './NotSureDescription';

interface ChoiceGroupWrapperProps {
  children: ReactNode;
  selectedAnswers: string[];
}

export const ChoiceGroupEdit = ({
  sectionContentState,
  setSectionContentState,
  isMultiSelect,
  answerLimit,
  isMandatory,
}: SelectProps) => {
  const [isNotSure, setIsNotSure] = useState(sectionContentState.selectedAnswers.includes(NOT_SURE_METADATA_KEY));

  const onChangeHandler = (newValue: string[] = []) => {
    if (newValue?.length > answerLimit) {
      newValue = newValue.slice(1, answerLimit + 1);
    }

    if (newValue.includes(NOT_SURE_METADATA_KEY)) {
      setIsNotSure(true);
      newValue = [NOT_SURE_METADATA_KEY];
    }

    if (!newValue.length) {
      setIsNotSure(false);
    }

    setSectionContentState(newValue);
  };

  const ChoiceGroupSingle = ({ children, selectedAnswers }: ChoiceGroupWrapperProps) => (
    <ChoiceGroup
      value={selectedAnswers[0]}
      onChange={(newValue) => {
        onChangeHandler(newValue ? [newValue] : []);
      }}
    >
      {children}
    </ChoiceGroup>
  );

  const ChoiceGroupMultiple = ({ children, selectedAnswers }: ChoiceGroupWrapperProps) => (
    <ChoiceGroup multiple value={selectedAnswers} onChange={onChangeHandler}>
      {children}
    </ChoiceGroup>
  );

  const ChoiceGroupWrapper = isMultiSelect ? ChoiceGroupMultiple : ChoiceGroupSingle;

  return (
    <Stack direction="column" gap="4">
      <ChoiceGroupWrapper selectedAnswers={sectionContentState.selectedAnswers}>
        {sectionContentState.allAnswers.map(({ slug, display_name }) => (
          <ChoiceGroupItem
            value={slug}
            key={slug}
            disabled={
              isNotSure ||
              (isMultiSelect &&
                sectionContentState.selectedAnswers.length >= answerLimit &&
                !sectionContentState.selectedAnswers.includes(slug))
            }
          >
            <Text fontWeight="semibold" size="b_sm">
              {display_name}
            </Text>
          </ChoiceGroupItem>
        ))}
        {isMandatory && (
          <ChoiceGroupItem value={NOT_SURE_METADATA_KEY}>
            <Text fontWeight="semibold" size="b_sm">
              <AppI18n k="sections.metadata.im_not_sure" />
            </Text>
          </ChoiceGroupItem>
        )}
      </ChoiceGroupWrapper>
      {isNotSure && <NotSureDescription />}
    </Stack>
  );
};
